import Cookies from 'js-cookie';
import Utils from 'common/scripts/utils';

class Favorite {
    constructor() {
        this.targetSelector = '.j-favorite-btn';
        this.activeClass = 'is-active';
    }

    /**
     * Инициализирует модуль
     * @param {object} options - настройки
     */
    init(options) {
        this.elem = options.elem;
        this.isFavoritePage = options.isFavoritePage || false;

        this._getElements();
        this._bindContext();
        this._bindEvents();
        this._setResults();
    }

    /**
     * Получает элементы
     * @private
     */
    _getElements() {
        this.targets = Array.from(this.elem.querySelectorAll(this.targetSelector));
        this.reset = this.elem.querySelector('.j-favorite-reset');
        this.button = document.querySelectorAll('.j-header-favorite');
        this.menuButton = document.querySelectorAll('.j-menu-favorite');
    }

    /**
     * Привязывает контекст
     * @private
     */
    _bindContext() {
        this._onClick = this._onClick.bind(this);
        this._resetAll = this._resetAll.bind(this);
    }

    /**
     * Метод навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        this.targets.forEach((target) => {
            if (!target.bindClick) {
                target.addEventListener('click', this._onClick);
                target.bindClick = true;
            }
        });

        if (this.reset) {
            this.reset.addEventListener('click', this._resetAll);
        }
    }

    /**
     * Метод записывает в массив с результатами данные из куки
     * @private
     */
    _setResults() {
        const cookies = Cookies.get('fav_f');

        this.results = [];

        if (cookies) {
            this.results = cookies.replace(/\s/g, '').split(',');
        }
    }

    /**
     * Событие при клике на кнопку
     * @param {Object} event - объект события
     * @private
     */
    _onClick(event) {
        event.preventDefault();
        event.stopPropagation();

        this.target = event.target.closest(this.targetSelector);
        this.id = String(this.target.dataset.id);

        if (this.target.classList.contains(this.activeClass)) {
            this._removeActive();
        } else {
            this._setActive();
        }

        this._setCookie();
        this._setButtonState();
    }

    /**
     * Событие удаления всего избранного
     * @param {object} event - объект события
     * @private
     */
    _resetAll(event) {
        event.preventDefault();

        this.results = [];
        this._setCookie();

        if (this.isFavoritePage) {
            this._removeAllItems();
        }
    }

    /**
     * Устанавливает кнопке активный класс и записывает id в массив с результатами
     * @private
     */
    _setActive() {
        this.target.classList.add(this.activeClass);
        this._setResults();
        this.results.push(this.id);
    }

    /**
     * Метод убирает активный класс и возвращает новый массив с результатами без того, по которому произошло событие
     * @private
     */
    _removeActive() {
        this.target.classList.remove(this.activeClass);
        this._setResults();
        this.results = this.results.filter((item) => {
            return item !== this.id;
        });

        if (this.isFavoritePage) {
            this._removeItem();
        }
    }

    /**
     * Удаляет карточку из списка избранного
     * @private
     */
    _removeItem() {
        const cards = Array.from(this.elem.querySelectorAll(`.favorites-flat-card[data-id="${this.id}"]`));

        cards.forEach((card) => {
            Utils.removeElement(card.closest('.favorites-flat-cards__item') || card);
        });

        this._changeTitle();
    }

    /**
     * Удаляет все квартиры из списка
     * @private
     */
    _removeAllItems() {
        const cards = Array.from(this.elem.querySelectorAll(`.favorites-flat-card`));

        cards.forEach((card) => {
            Utils.removeElement(card.closest('.favorites-flat-cards__item') || card);
        });

        this._showEmptyContent();
    }

    /**
     * Метод заменяет заголовок избранного при удалении элементов
     * @private
     */
    _changeTitle() {
        const title = document.querySelector('.j-favorite-title');

        if (!title) {
            return;
        }

        const word = Utils.pluralWord(this.results.length, ['Добавлена', 'Добавлено', 'Добавлено']);
        const flatWord = Utils.pluralWord(this.results.length, ['квартира', 'квартиры', 'квартир']);

        if (this.results.length) {
            title.innerHTML = `${word} ${this.results.length} ${flatWord}`;
        } else {
            this._showEmptyContent();
        }
    }

    /**
     * Метод показывает скрытый блок с контентом для пустого избранного
     * @private
     */
    _showEmptyContent() {
        const hiddenClass = 'is-hidden';

        this.elem.classList.add(hiddenClass);

        const emptyBlock = document.querySelector('.j-favorite-empty');

        if (emptyBlock) {
            emptyBlock.classList.remove(hiddenClass);
        }

        const shareButtons = document.querySelector('.j-favorite-share');

        if (shareButtons) {
            shareButtons.classList.add(hiddenClass);
        }

        this._setFlatsId();
    }

    /**
     * Записывает массив с результатами в куки
     * @private
     */
    _setCookie() {
        Cookies.set('fav_f', this.results.toString());
    }

    /**
     * Меняет состояние кнопки избранного в хедере
     * @private
     */
    _setButtonState() {
        const isActive = this.results.length > 0 || this.targets.reduce((acc, target) => {
            return acc || target.classList.contains('is-active');
        }, false);

        this.button.forEach((button) => {
            button.classList.toggle(this.activeClass, isActive);
        });

        this.menuButton.forEach((button) => {
            button.classList.toggle(this.activeClass, isActive);
        });
    }
}

export default Favorite;
